import { Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { cssVar } from '@feathr/hooks';

import { useMetaConnectionData } from './MetaConnectedView.hooks';
import MetaConnectionOverview from './MetaConnectionOverview';
import MetaCreateCampaignCard from './MetaCreateCampaignCard';

function MetaConnectedView(): JSX.Element {
  const connectionData = useMetaConnectionData();

  return (
    <Stack gap={cssVar('--spacing-8')}>
      <MetaCreateCampaignCard />
      <MetaConnectionOverview connectionData={connectionData} />
    </Stack>
  );
}

export default MetaConnectedView;
